"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateMutation;
function updateMutation(mutation, originalOffset, originalLength, newLength) {
  // two cases we can reasonably adjust - disjoint mutations that
  // happen later on where the offset will need to be changed, and
  // mutations that completely contain the new one where we can adjust
  // the length.
  var lengthDiff = newLength - originalLength;

  if (originalOffset + originalLength <= mutation.offset) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + lengthDiff
    });
  }
  if (originalOffset >= mutation.offset && originalOffset + originalLength <= mutation.offset + mutation.length) {
    return Object.assign({}, mutation, {
      length: mutation.length + lengthDiff
    });
  }

  return mutation;
}


//////////////////
// WEBPACK FOOTER
// ./~/Dante2/~/draft-convert/lib/util/updateMutation.js
// module id = 232
// module chunks = 0